import { AppState } from "../types/app-state";

export const getInitialState = (): AppState => {
  return {
    loader: {
      loading: true,
      message: 'Loading',
      customImage: undefined,
    },

    accountType: undefined!,
    isError: false,
    initialized: false,
    accessToken: undefined,
    refreshToken: undefined,
    isAuthenticated: false,
    permissions: [],
    accountIds: [],
    role: '',

    userDetails: {
      isError: false,
      isLoading: false,
      error: undefined,
      data: {
        id: null!,
        avatar: '',
        emailAddress: '',
        firstName: '',
        lastName: '',
        mobileNumber: '',
        associatedAccount: '',
        status: '',
        lastLogIn: '',
        invitedById: null!,
        invitedByDate: '',
        identityId: '',
        fullName: '',
        accountId: null!,
        roleId: null!,
        userAccountStatus: null!,
      },
    },

    associatedAccounts: {
      isLoading: true,
      isError: false,
      error: undefined,
      data: [],
    },

    favoriteProjects: {
      isLoading: true,
      isError: false,
      error: undefined,
      data: [],
    },

    client: {
      isLoading: true,
      isError: false,
      error: undefined,
      data: {
        accountId: null!,
        accountName: null!,
        displayName: null!,
        isActive: false,
        contactFirstName: null!,
        contactLastName: null!,
        contactPhone: null!,
        contactEmailAddress: null!,
        siteMapUri: null!,
        accountLogoBase64: null!,
        preferredTimeZone: null!,
        accountTemplate: null!,
        propertyTemplate: null!,
        accountType: null!,
      },
    },

    project: {
      isLoading: true,
      isError: false,
      error: undefined,
      data: {
        accountId: null!,
        accountName: null!,
        displayName: null!,
        isActive: false,
        contactFirstName: null!,
        contactLastName: null!,
        contactPhone: null!,
        contactEmailAddress: null!,
        siteMapUri: null!,
        accountLogoBase64: null!,
        preferredTimeZone: null!,
        accountTemplate: null!,
        propertyTemplate: null!,
        accountType: null!,
      },
    },
  };
};
